import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { nameof } from 'ts-simple-nameof';
import { DialogSubscriptionComponent } from '../../../../dialog/dialog-subscription.component';
import { DialogService } from '../../../../dialog/dialog.service';
import { ValidGradingRankCode } from '../../../../shared/interface/valid-grading-rank-code.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { nameofExt } from '../../../../shared/services/nameof-extend';
import { TableStateService } from '../../../../tables/table-state.service';
import {
    ActionButtonClickEvent,
    ActionComplete,
    ColumnDefinition,
    TableFilterItem
} from '../../../../tables/table.types';
import { FacultyCategoryEditComponent } from './faculty-category-edit/faculty-category-edit.component';
import { FacultyCategoryService } from './faculty-category.service';

@Component({
    selector: 'app-registrar-admin-maintenance-faculty-category',
    templateUrl: './faculty-category.component.html',
    styleUrls: ['./faculty-category.component.scss']
})
export class FacultyCategoryComponent extends DialogSubscriptionComponent implements OnInit {
    tableName: string = 'facultyStaffType';
    baseUrl: string = 'validGradingRankCode';
    filters: Array<TableFilterItem> = [
        {
            property: nameof<ValidGradingRankCode>((m) => m.rankCode),
            inputType: 'input'
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.title),
            inputType: 'input'
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.isEnabled),
            inputType: 'select',
            clearButton: true,
            selectOptions: of([
                {
                    text: 'Yes',
                    value: 'YES'
                },
                {
                    text: 'No',
                    value: 'NO'
                }
            ])
        }
    ];
    columns: Array<ColumnDefinition> = [
        {
            property: nameof<ValidGradingRankCode>((m) => m.id)
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.rankCode)
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.title),
            disableSort: true
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.isEnabled),
            booleanAsYesNo: true
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.dateCreated),
            isDate: true,
            dateFormat: 'short'
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.createdByName),
            disableSort: true
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.lastUpdated),
            isDate: true,
            dateFormat: 'short'
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.lastUpdatedByName),
            disableSort: true
        },
        {
            property: 'actions',
            actions: [
                {
                    discriminator: 'edit',
                    icon: 'edit',
                    toolTip: `Click to edit ${nameofExt<ValidGradingRankCode>((m) => m.rankCode)}`,
                    clickCallBack: {
                        this: this,
                        observable: (event: ActionButtonClickEvent<ValidGradingRankCode>) => {
                            return this.service.show(event.element.id);
                        },
                        function: this.show
                    }
                },
                {
                    discriminator: 'delete',
                    icon: 'delete',
                    toolTip: `Click to delete ${nameofExt<ValidGradingRankCode>((m) => m.rankCode)}`,
                    clickCallBack: {
                        this: this,
                        observable: (event: ActionButtonClickEvent<ValidGradingRankCode>) => {
                            return this.service.delete(event.element.id);
                        },
                        function: (event: ActionButtonClickEvent<ValidGradingRankCode>) => {
                            this.alert.toastSuccess(`${event.element.rankCode} deleted!`);
                            this.tableState.sendToTable({
                                tableName: this.tableName,
                                element: event.element,
                                remove: true
                            });
                            return {
                                completed: true
                            };
                        }
                    }
                }
            ]
        }
    ];
    constructor(
        private service: FacultyCategoryService,
        private dialog: DialogService<ValidGradingRankCode>,
        private alert: AlertService,
        private tableState: TableStateService
    ) {
        super();
    }

    ngOnInit(): void {}

    show(event: ActionButtonClickEvent<ValidGradingRankCode> = null): ActionComplete {
        const element = event?.observableValue ?? { id: -1 };
        this.addSubscription(
            this.dialog.response.subscribe((v) => {
                if (v.dialogAlias === 'validGradingRank') {
                    this.tableState.sendToTable({
                        tableName: this.tableName,
                        element: v.payload,
                        update: true
                    });
                }
            }),
            this.dialog.show(element, {
                component: FacultyCategoryEditComponent,
                dialogAlias: 'validGradingRank',
                title: element.id === -1 ? 'New Grading Rank Code' : `${element.rankCode} ${element.title}`,
                uniqueId: `validStaffCode${element.id}`
            })
        );
        return {
            completed: true
        };
    }
}
